import styled from "styled-components";

const Wrapper = styled.div`
	margin-top: 30px;
`;

export { Wrapper };
